import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { Member } from 'src/app/model/member.model';
import { environment } from 'src/environments/environment';
import { MemberSub, MemberSubProjectDs } from "src/app/model/memberSub.model";
import { MemberSubService } from "../memberSub/memberSub.service";
import Swal from 'sweetalert2';
import { NgxSignaturePadComponent, NgxSignatureOptions } from '@eve-sama/ngx-signature-pad';

@Component({
  selector: 'app-memberSub',
  templateUrl: './memberSub.component.html',
  styleUrl: './memberSub.component.css'
})
export class MemberSubComponent {
  @ViewChild('sig', { static: false }) pad!: NgxSignaturePadComponent;
  options: NgxSignatureOptions = {
    backgroundColor: '#fff',
    width: 500,
    height: 500
  };
  CompanyID: string;
  UserID: string;
  Liff_ID: string;
  LoginUser: Member;
  isOptionLoading: boolean = false;
  baseUrl = environment.baseUrl;
  editModel: MemberSub[] = [];
  showDialog = false;
  /**紀錄簽名檔的資料 */
  drawData: MemberSubProjectDs;
  subscribes: Subscription = new Subscription();
  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private MemberSubService: MemberSubService,
      private authenticationService: AuthenticationService){
  }
  ngOnInit():void{
    var that = this;
    // 取得querystring param
    var query = this.route.queryParams.subscribe((value) => {
      this.CompanyID = value['CompanyID'];
      this.UserID = value['UserID'];
      this.Liff_ID = value['Liff_ID'];
    });

    var currentUser = this.authenticationService.currentMember.subscribe(
      (member) => {
        this.LoginUser = member;
      }
    );
    this.GetSubMemberData();
    this.subscribes.add(query);
    this.subscribes.add(currentUser);
  }
  
  GetSubMemberData(){
    this.isOptionLoading = true;
    var data = this.MemberSubService.GetSubMemberData(this.CompanyID,this.UserID).subscribe(result=>{
        this.GetDataSuccess(result);
    });
    this.subscribes.add(data);
  }

  GetDataSuccess(result: any){
      if(result.ErrorFlag == "1"){
        Swal.fire({
                  icon: 'error',
                  title: result.ErrorMsg
                });
        return;
      }else if(!!result.ErrorFlag && result.ErrorFlag == '2'){
              Swal.fire({
                        icon: 'error',
                        title: "您目前無法進行預約，請聯絡該門市，謝謝。",
                        confirmButtonText: '確定'
                      }).then((result) => {
                        if (result.isConfirmed) {
                          this.router.navigate(['/'],{
                            queryParams: {
                              CompanyID: this.CompanyID,
                              UserID: this.UserID,
                              Liff_ID: this.Liff_ID
                            },
                          });
                        }
                      });
                      
                      return;
      }
      this.editModel = result; 
      this.isOptionLoading = false;
  }
  /**簽名 */
  Sign(data: MemberSubProjectDs) {
        this.showDialog = true;
        this.drawData = data;
  }
  /**清除簽名
  */
  clear() {
      this.pad.clear();
  }
  /**儲存簽名 */
  save() {
      if (this.pad.isEmpty()) {
        alert('請先簽名');
        return;
      }
      const dataURL = this.pad.toDataURL();
      this.drawData.SignPath = dataURL;
      this.MemberSubService.SaveSign(this.drawData).subscribe((res: any)=>{ 
        this.showDialog = false;
        if(res.ErrorFlag == "1")
        {
          Swal.fire({
                  icon: 'error',
                  title: res.ErrorMsg
                });
        }
        //取得該筆明細資料
        for(let sub of this.editModel){
          const target = sub.SubProDs.find(s=>
            s.UseDate == this.drawData.UseDate &&
            s.PetNo  == this.drawData.PetNo  &&
            s.ItemNo  == this.drawData.ItemNo  &&
            s.StoreNo  == this.drawData.StoreNo  
          );

          if(target){
            Object.assign(target, res); // res 是最新資料
            this.drawData.SignPath = res.SignPath;
            break; // 找到後就跳出
          }
        }
        //最後記得清除
        this.pad.clear();
      });
  }
  onBegin() { /* 開始簽名事件 */ }
  onEnd() { /* 結束簽名事件 */ }
  ngOnDestroy(): void {
    this.subscribes.unsubscribe();
  }
}
